import { companyMemory } from "../../Objects/Memory/Memory"
import { CompanyEntity } from "../../Objects/Company/CompanyEntity"
import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { GetRequest } from "../../services/ApiClientService"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { useTranslation } from "react-i18next"
import { useUpgradePlan } from "../../context/useUpgradePlanContext"

export const useGetCompany = () => {
  const { t } = useTranslation("general")

  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  const { openPlan } = useUpgradePlan()

  const handleGetCompany = async (
    onSuccess: any,
    rote: string = API_ROUTES.COMPANY.GET_ALL,
    showErrorMessage = true,
  ) => {
    enableLoad()
    try {
      const response = await GetRequest<CompanyEntity[]>(rote)

      if (response.success) {
        const company = response.data?.map((e: any) => new CompanyEntity(e))

        if (company && company.length > 0) {
          companyMemory.setUpdateData(company[0])
        }

        onSuccess()

        return true
      }

      throw new Error(response.message)
    } catch (e: unknown) {
      if (showErrorMessage) {
        const message = e instanceof Error ? e.message : t("label_unknown_error_description")
        setError(t("label_title_erro"), message)
      }

      return false
    } finally {
      disableLoad()
    }
  }

  return {
    handleGetCompany,
  }
}
